let Choices = require( 'choices.js' );

let gravity_forms = (function( $ ) {

	let selects = [];

	let _init = function() {
		let $gforms = $( '.gform_wrapper' );

		if ( $gforms.length > 0 ) {
			$( document ).bind( 'gform_post_render', _post_render );

			_init_choices( 1 );
			_init_choices( 2 );
		}
	};

	let _init_choices = function( form_id ) {
		$( '#gform_' + form_id ).find( 'select' ).each( function() {
			const $select = $(this);
			let id_attr = $select.attr( 'id' );

			if ( typeof selects[id_attr] === "undefined" || !$select.hasClass('choices__input') ) {
				selects[id_attr] = new Choices($(this)[0], {
					shouldSort: false
				});
			}
		} );
	};

	let _post_render = function( e, form_id ) {
		_init_choices( form_id );
	};

	$( document ).on( 'ready', _init );

	return {};

})( jQuery );

module.exports = gravity_forms;